var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLevelSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--noto",
    preserveAspectRatio: "xMidYMid meet",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116 4H12c-4.42 0-8 3.58-8 8v104c0 4.42 3.58 8 8 8h104c4.42 0 8-3.58 8-8V12c0-4.42-3.58-8-8-8z",
    fill: "#194fa5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.7 4H11.5A7.555 7.555 0 0 0 4 11.5v97.9c-.01 4.14 3.34 7.49 7.48 7.5H109.6c4.14.01 7.49-3.34 7.5-7.48V11.5c.09-4.05-3.13-7.41-7.18-7.5h-.22z",
    fill: "#0B3954"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M43.3 25.5h.2v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M51.9 25.3v.2h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6 37.7V25.6h6c1.35.01 2.45-1.07 2.46-2.42c.01-.58-.19-1.14-.56-1.58l-7.7-9.2l-.4-.4c-.4-.45-.92-.76-1.5-.9a3.554 3.554 0 0 0-4.2 1.3c0 .1-.1.1-.2.1l-7.6 9.2c-.86 1.04-.72 2.57.32 3.44c.44.37 1.01.57 1.58.56h5.9v12.1c0 1.66 1.34 3 3 3a3.15 3.15 0 0 0 2.9-3.1z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8 13.8l.1 12.1h6a2.437 2.437 0 0 1 2.46 2.42c.01.58-.19 1.14-.56 1.58l-7.7 9.2c-.1.2-.3.3-.4.4c-.4.42-.87.76-1.4 1c-1.53.54-3.24.01-4.2-1.3c-.1 0-.1-.1-.2-.2l-7.6-9.2c-.86-1.04-.72-2.57.32-3.44c.44-.37 1.01-.57 1.58-.56h5.9L78 13.7c0-1.66 1.34-3 3-3a3.16 3.16 0 0 1 2.8 3.1z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.4 46h-77a7.844 7.844 0 0 0-7.9 7.8v51.7a7.844 7.844 0 0 0 7.8 7.9h77.1c4.34.03 7.87-3.46 7.9-7.8V53.9a7.995 7.995 0 0 0-7.9-7.9zm-1 58.6H27.6V55.1h74.8v49.5z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7 65.2a3.807 3.807 0 0 0 1.3-5.1c-.87-1.68-2.95-2.33-4.63-1.46c-.09.05-.19.1-.27.16l1.8 3.2l-1.8-3.2a3.807 3.807 0 0 0-1.3 5.1c1 1.71 3.19 2.29 4.9 1.3z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9 84.8h.9v15.1c-.02 1.25.97 2.28 2.22 2.3h.08a2.34 2.34 0 0 0 2.3-2.3V84.8h.8v15.1c-.02 1.25.97 2.28 2.22 2.3h.08a2.34 2.34 0 0 0 2.3-2.3V84.8h.8a2.22 2.22 0 0 0 2.2-2.2V68.8a2.22 2.22 0 0 0-2.2-2.2H36.9a2.22 2.22 0 0 0-2.2 2.2v13.8a2.22 2.22 0 0 0 2.2 2.2z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6 65.1a3.807 3.807 0 0 0 1.3-5.1c-.87-1.68-2.95-2.33-4.63-1.46c-.09.05-.19.1-.27.16l1.8 3.2l-1.8-3.2a3.807 3.807 0 0 0-1.3 5.1c.87 1.68 2.95 2.33 4.63 1.46c.09-.05.18-.1.27-.16z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9 84.7h.8v15.1c-.02 1.25.97 2.28 2.22 2.3H62a2.34 2.34 0 0 0 2.3-2.3V84.7h.8v15.1a2.34 2.34 0 0 0 2.3 2.3a2.396 2.396 0 0 0 2.3-2.3V84.7h1a2.22 2.22 0 0 0 2.2-2.2V68.8a2.22 2.22 0 0 0-2.2-2.2H58.9a2.22 2.22 0 0 0-2.2 2.2v13.8a2.143 2.143 0 0 0 2.2 2.1z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6 65.1a3.807 3.807 0 0 0 1.3-5.1c-.87-1.68-2.95-2.33-4.63-1.46c-.09.05-.19.1-.27.16l1.8 3.2l-1.8-3.2a3.807 3.807 0 0 0-1.3 5.1a3.39 3.39 0 0 0 4.55 1.5c.12-.06.24-.13.35-.2z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7 84.7h.9v15a2.3 2.3 0 0 0 4.6 0v-15h.8v15.1a2.3 2.3 0 0 0 4.6 0V84.7h.9a2.22 2.22 0 0 0 2.2-2.2V68.8a2.22 2.22 0 0 0-2.2-2.2H80.7a2.22 2.22 0 0 0-2.2 2.2v13.8a2.143 2.143 0 0 0 2.2 2.1z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7 12.9c0-2.3-1.6-3-10.8-2.7c-7.7.3-11.5 1.2-13.8 4s-2.9 8.5-3 15.3c0 4.8 0 9.3 2.5 9.3c3.4 0 3.4-7.9 6.2-12.3c5.4-8.7 18.9-10.6 18.9-13.6z",
    fill: "#68abe6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevelSvg);
export default __webpack_public_path__ + "static/media/LevelSVG.2141bf222cc8680f572d15d8e7a6b644.svg";
export { ForwardRef as ReactComponent };